import React, { useState } from 'react';
import {
  Button,
  Dimmer,
  Loader,
  Grid,
  Checkbox,
} from 'semantic-ui-react';
import { useStitchMembers } from '../../StitchMembers';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import 'quill-emoji/dist/quill-emoji.css';
import { parseNote } from '../../Common/memberUtils';

function NoteInput(props) {
  const [loading, setLoading] = useState(false);
  const [isMemo, setIsMemo] = useState(false);
  const { memberOne, actions } = useStitchMembers();
  const [quill, setQuill] = useState();
  const [error, setError] = useState(false);

  const quillModules = {
    toolbar: false,
  };
  // =============================
  const handleSubmit = async () => {

    setError(false)
    setLoading(true);
    try {
      // Get plain text from editor and parse any html tags or unsupported characters
      const contentFinal = parseNote(quill.getEditor().getText().trim())
      await actions.updateNote(
        memberOne,
        contentFinal,
        new Date().toISOString(),
        isMemo,
      );
      let range = quill.getEditor().getSelection();
      let position = range ? range.index : 0;
      quill.getEditor().deleteText(0, position);
    }
    catch (e) {
      setError(true)
      console.error(e);
    }
    finally {
      setLoading(false);
    }
  };

  return (
    <Grid>
      {loading && (
        <Dimmer active inverted>
          <Loader inverted>Loading</Loader>
        </Dimmer>
      )}
      <Grid.Row columns={2}>
        <Grid.Column width={12}>
          <div style={{ height: '120px', overflowY: 'auto', paddingTop: "4px" }}>
            <ReactQuill
              theme="snow"
              ref={(el) => setQuill(el)}
              placeholder="Write something here"
              style={{ backgroundColor: '#fff', height: '85px' }}
              modules={quillModules}
            />
            {error ? <p style={{ color: 'red', paddingTop: "4px" }}>An unknown error occurred. Please try again.</p> : null}
          </div>
        </Grid.Column>
        <Grid.Column width={4}>
          <Grid style={{ paddingRight: '2em' }}>
            <Grid.Row>
              <Grid.Column>
                <Checkbox
                  size="mini"
                  label={
                    <label>
                      <small className="grey text thin">
                        This is a memo.
                      </small>
                    </label>
                  }
                  checked={isMemo}
                  onClick={() => setIsMemo(!isMemo)}
                />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column>
                <Button
                  style={{
                    backgroundColor: '#1b2a4e',
                    color: '#fff',
                  }}
                  fluid
                  onClick={handleSubmit}
                >
                  Write Notes
                </Button>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Grid.Column>
      </Grid.Row>
    </Grid>
  );
}

export default NoteInput;
